import { inject, observer } from "mobx-react";
import SensorEventItem from "./components/sensor-event-item/SensorEventItem";
import styles from "./sensor-events.module.css";
import { ManageLocationStore, SensorEvent } from "../../store/store";
import BasicSpinner from "../../../../components/basic-spinner/BasicSpinner";

export type SensorEventsProps = {
    manageLocationsStore?: ManageLocationStore;
};

function SensorEvents(props: SensorEventsProps) {
    const manageLocationsStore = props.manageLocationsStore!;
    const sensorEventList = manageLocationsStore.sensoreEventList;
    const loading = manageLocationsStore.loadingSensor;

    const getSensorEventList = () => {
        return sensorEventList.map((sensorEvent: SensorEvent) => {
            return (
                <SensorEventItem
                    eventType={sensorEvent.eventType}
                    sensorType={sensorEvent.sensorType}
                    timestamp={sensorEvent.timestamp}
                />
            );
        });
    };

    const content = () => {
        if (loading)
            return (
                <div className={styles["sensor-spinner"]}>
                    <BasicSpinner />
                </div>
            );

        return getSensorEventList();
    };

    const render = () => {
        return (
            <div className={styles["sensor-events"]}>
                <div className={styles["header"]}></div>
                <div className={styles["list-container"]}>{content()}</div>
            </div>
        );
    };

    return render();
}

export default inject("manageLocationsStore")(observer(SensorEvents));
